<template>
  <div class="banner-text-con">
    <p>25年来，戴尔科技的飞跃颠覆了世界</p>
    <p> 25年后，DELL Precision工作站将会进化成一艘无所不能的飞船——</p>
    <p class="bold">「DELL Precision 2047号」</p>
    <p class="padding-b30"> 不断探索和开拓各个领域的新界限</p>
    <p> 「DELL Precision 2047号」的样子</p>
    <p> 存在于每一位创造者的想象之中</p>
    <p> 期待你尽情呈现它的炫酷外观、强大性能</p>
    <p class="bold-p">让它带领我们，共赴2047！</p>
    <div class="match-button">
      <span @click="toHeaderDidClick_tab">了解参赛须知</span>
      <span @click="uploadWork" class="upload-btn" v-if="userWorkId">{{ upLoadWorkOrMyWork }}</span>
    </div>
    <div class="match-arrangement page-box" id="eventArrangement">赛事安排</div>
    <ul class="match-list">
      <li>
        <p class="num">01</p>
        <div class="text">
          <div class="title">参赛报名</div>
          <div class="data">{{this.$store.state.isMobile? '2022.9.26-10.26' : '2022年9月26日-10月26日'}}</div>
        </div>
      </li>
      <li>
        <p class="num">02</p>
        <div class="text">
          <div class="title">入围作品审核&专家评审</div>
          <div class="data">{{this.$store.state.isMobile? '2022.10.27-11.7' : '2022年10月27日-11月7日'}}</div>
        </div>
      </li>
      <li>
        <p class="num">03</p>
        <div class="text">
          <div class="title">获奖公示</div>
          <div class="data">{{this.$store.state.isMobile? '2022.11.16' : '2022年11月16日'}}</div>
        </div>
      </li>
    </ul>
    <div class="decorate1"></div>
  </div>
</template>

<script>
export default {
  name: "BannerText",
  data(){
    return{
      isMobel: false,
      upLoadWorkOrMyWork: '上传作品',
      userWorkId: ''
    }
  },
  mounted() {
    this.userWorkId = this.$tool.getLS( 'userWorkId',1)
    if(this.userWorkId){
      this.upLoadWorkOrMyWork = '我的作品';
    }
  },
  methods: {
    toHeaderDidClick_tab(){
      this.$parent.$children[0].didClick_tab('entryInformation',2,'参赛须知')
    },
    uploadWork() {
      this.gioAction('precision25thart_uploadClick')
      // this.$alert('活动将于9.26正式开始，敬请期待!', {
      //   confirmButtonText: '确定',
      //   callback: action => {
      //   }
      // });
      if(this.$tool.isLogin()){
        if(this.userWorkId){
          this.$tool.setLS('workId', this.userWorkId,1)
          this.$router.push({path:'/opusInfo', query: { id: this.userWorkId }});
        }else{
          this.$router.push({path:'/uploadOpus'});
        }
      }else{
        this.$confirm('请登录！',  {
          distinguishCancelAndClose: true,
          confirmButtonText: '登录',
          cancelButtonText: '关闭'
        })
            .then(() => {
              this.$router.push({path:'/login'});
            })
            .catch(action => {
            });
      }
    }
  }
}
</script>

<style scoped lang="less">
  .banner-text-con{
    //margin-top: 488px;
    text-align: center;
    position: relative;
    p{
      //font-size: 18px;
      color: #14456e;
      margin: 0;
      padding-bottom: 13px;
      &.bold{
        font-weight: bold;
        //font-size: 27px;
      }
      &.bold-p{
        font-weight: bold;
        //font-size: 27px;
        padding-bottom: 33px;
      }
      &.padding-b30{
        padding-bottom: 30px;
      }
    }
    .match-button{
      //font-size: 17px;
      span{
        display: inline-block;
        width: 183px;
        height: 47px;
        color: #fff;
        line-height: 47px;
        background: url("../assets/images/match_button.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 33px;
        //font-size: 17px;
        /*&:last-child{*/
          /*margin-left: 66px;*/
        /*}*/
      }
      .upload-btn{
        animation: myFrame 1.5s linear infinite;
        -webkit-animation: myFrame 1.5s linear infinite;
      }
      @keyframes myFrame{
        50%{
          transform: scale(110%);
        }
      }
    }
    .match-arrangement{
      padding-top: 60px;
      //font-size: 25px;
      color: #5c75a6;
      font-weight: bold;
    }
    .match-list{
      display: flex;
      justify-content: center;
      //margin: 40px 0 130px 0;
      li{
        padding: 0;
        display: inline-block;
        background: url("../assets/images/match_ac.png") no-repeat;
        background-size: 100% 100%;
        font-weight: bold;
        border-radius: 14px;
        box-shadow: 5px 10px 20px rgba(0, 0, 0, .08);
        .num{
          position: relative;
          padding: 15px 0 0 26px;
          font-size: 85px;
          color: #5c75a6;
          text-align: left;
          &:before{
            content: '';
            position: absolute;
            top: 15px;
            left: 32px;
            width: 25px;
            height: 8px;
            background: #5c75a6;
          }
        }
        .text{
          text-align: left;
          color: #31446a;
          margin: 0 7px;
          border-top: 1px solid #dde2f0;
          padding-left: 13px;
          .title{
            //font-size: 17px;
            padding:20px 0 11px;
          }
          .data{
            //font-size: 15px;
          }
        }
      }
    }
  }
  //pc
  @media (min-width: 992px){
    .banner-text-con{
      /*padding-top: 488px;*/
      p{
        font-size: 18px;
        &.bold{
          font-size: 27px;
        }
        &.bold-p{
          font-size: 27px;
        }
      }
      .match-list{
        margin: 40px 0 130px 0;
        li{
          width: 261px;
          height: 231px;
          .text{
            .title{
              font-size: 17px;
            }
            .data{
              font-size: 15px;
            }
          }
          &:nth-child(2){
            margin: 0 20px;
          }
        }
      }
      .match-button{
        font-size: 17px;
        span{
          font-weight: normal;
          font-size: 17px;
          cursor: pointer;
        }
      }
      .decorate1{
        position: absolute;
        top: 260px;
        left: 50%;
        transform: translateX(-500px);
        width: 174px;
        height: 150px;
        background: url("../assets/images/decorate1.png") no-repeat;
        background-size: 100% 100%;
      }
      .match-arrangement{
        font-size: 25px;
      }
    }
  }
  //mobile
  @media (max-width: 992px) {
    .banner-text-con{
      p{
        font-size: 24px;
        &.bold{
          font-size: 34px;
        }
        &.bold-p{
          font-size: 34px;
        }
      }
      .match-list{
        margin: 40px 0 60px 0;
        li{
          width: 226px;
          height: 246px;
          .text{
            .title{
              font-size: 21px;
            }
            .data{
              font-size: 19px;
            }
          }
          &:nth-child(2){
            margin: 0 12px;
          }
        }
      }
      .match-button{
        font-size: 21px;
        span{
          font-weight: bold;
          font-size: 21px;
        }
      }
      .match-arrangement{
        font-size: 29px;
      }
    }
  }
</style>
